import * as React from 'react'
import { ReactNode } from 'react'
import { Menu, type MenuProps } from 'antd'
import { MenuFoldOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import logo_horizontal from '../../../../assets/logo_horizontal.svg'
import { CustomDrawer } from '../CustomDrawer'

import './index.less'

type MenuItem = Required<MenuProps>['items'][number]

type PageItemType = {
  link: string
  label: ReactNode
  key: string
}

interface BurgerMenuProps {
  pages: PageItemType[]
  currentPagePathname?: string
}

export const BurgerMenu = ({ pages, currentPagePathname }: BurgerMenuProps): JSX.Element => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="burgerMenu">
      <CustomDrawer
        representativeButton={<MenuFoldOutlined />}
        header={
          <div className="drawerHeaderTitle">
            <img src={logo_horizontal} alt={t('logo.alt')} />
          </div>
        }
        placement={'left'}
      >
        <Menu
          mode="vertical"
          selectedKeys={[currentPagePathname ?? '']}
          items={pages?.map((item: PageItemType) => {
            return {
              key: item.key,
              label: item.label,
            } as MenuItem
          })}
          onClick={({ key }) => navigate(pages.find((t: { key: string }) => t.key === key)?.link ?? '/')}
        />
      </CustomDrawer>
    </div>
  )
}
